import { StyledButton } from "./styles";
import { ButtonProps } from "../types";

export const Button = ({
  color,
  fixedWidth,
  children,
  onClick,
}: ButtonProps) => (
  <StyledButton color={color} fixedWidth={fixedWidth} onClick={() => {window.location.href = 'https://wa.me/6281296042874?text=saya mau tanya tentang smp'}}>
    {children}
  </StyledButton>
);
